// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"464b370c4ea9d386","3972":"3ed375e49b9b72ae"}[chunkId] + ".css";
};